"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _cuid = _interopRequireDefault(require("cuid"));
var TimeFill = function TimeFill(props) {
  var uniqueId = (0, _cuid["default"])();
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({
    uniqueId: uniqueId
  }, props), /*#__PURE__*/_react["default"].createElement("title", null, "time-fill"), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10 0c-5.523 0-10 4.477-10 10s4.477 10 10 10c5.523 0 10-4.477 10-10v0c0-5.523-4.477-10-10-10v0zM14.76 10.96h-4.76c-0.349-0.004-0.653-0.194-0.818-0.475l-0.002-0.005-2.86-4.76c-0.13-0.162-0.209-0.371-0.209-0.598 0-0.53 0.43-0.96 0.96-0.96 0.4 0 0.743 0.244 0.887 0.592l0.002 0.006 2.58 4.28h4.22c0.53 0 0.96 0.43 0.96 0.96s-0.43 0.96-0.96 0.96v0z"
  }));
};
var _default = exports["default"] = TimeFill;